var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',{staticClass:"mx-0",attrs:{"loading":_vm.isDownloading},on:{"click":_vm.handleDownload}},[_c('BaseIcon',{staticClass:"mr-2",attrs:{"icon":"cloud-arrow-down","tag":"i"}}),_vm._v("\n  Download\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }